import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 抄表接口
 **********************************************************************************/
export default {

  //******************************************************************************************************************看板
  /**
   * 获取单位下电表数、欠费电表数、电表上线数、业主数、告警数
   */
  getKanbanCountInfo: (unitId, success, failure) => {
    Axios.post('/meterReading/getKanbanCountInfo.do', {
      unitId
    }, success, failure)
  },

  //******************************************************************************************************************电表管理

  /**
   * 添加或更新表信息
   * @param billingModePkid:所选计费方式id
   * @param deductionFeeDay:扣款日,每月15扣费就传15
   * @param basicElectricityCharges:基本费用 单位为分
   * @param accountType:接算方式 0后付费 1预付费
   * @param meterRunType :表类型：1预付费表(充值表) 2普通表
   * @param meterType:区分电表水表等  electric电表  water水表
   */
  saveMeterReadingConfig: (deviceNos, billingModePkid, deductionFeeDay, basicElectricityCharges, accountType, meterRunType, meterType, freeQuota, success, failure) => {
    Axios.post('/meterReading/saveMeterReadingConfig.do', {
      deviceNos,
      billingModePkid,
      deductionFeeDay,
      basicElectricityCharges,
      accountType,
      meterRunType,
      meterType,
      freeQuota
    }, success, failure)
  },
  /**
   * 更新电表设备倍率
   */
  updateMeterMagnification: (deviceNo, magnification, password, success,
    failure) => {
    Axios.post('/meterReading/updateMeterMagnification.do', {
      deviceNo,
      magnification,
      password
    }, success, failure)
  },
  /**
   * 更新电表设备计费方式
   */
  updateMeterBillingMode: (deviceNo, billingModePkid, password, success,
    failure) => {
    Axios.post('/meterReading/updateMeterBillingMode.do', {
      deviceNo,
      billingModePkid,
      password
    }, success, failure)
  },
  /**
   * 更新电表设备扣费日期
   */
  updateDeductionFeeDay: (deviceNo, deductionFeeDay, password, success,
    failure) => {
    Axios.post('/meterReading/updateDeductionFeeDay.do', {
      deviceNo,
      deductionFeeDay,
      password
    }, success, failure)
  },

  /**
   * 更改基本电费分摊值
   */
  changeBaseMoney: (deviceNo, basicElectricityCharges, success,
    failure) => {
    Axios.post('/meterReading/basicElectricityCharges.do', {
      deviceNo,
      basicElectricityCharges
    }, success, failure)
  },

  /**
   * 移除指定设备列表的抄表配置
   */
  removeMeterReadingConfig: (deviceNos, success, failure) => {
    Axios.post('/meterReading/removeMeterReadingConfig.do', {
      deviceNos
    }, success, failure)
  },
  /**
   * 查询指定抄表设备的配置信息
   */
  getConfigByDeviceNos: (deviceNos, success, failure) => {
    Axios.post('/meterReading/getConfigByDeviceNos.do', {
      deviceNos
    }, success, failure)
  },
  /**
   * 查询指定抄表设备的配置信息,不做权限的
   */
  getConfigByDeviceNosWithNoToken: (deviceNos, success, failure) => {
    Axios.post('/meterReading/getConfigByDeviceNosWithNoToken.do', {
      deviceNos
    }, success, failure)
  },
  /**
   * 查询指定单位下的计费表列表
   */
  getMeterReadingConfigListByUnitId: (unitId, activeName, success, failure) => {
    Axios.post('/meterReading/getMeterReadingConfigListByUnitId.do', {
      unitId,
      activeName
    }, success, failure)
  },
  /**
   * 分页获取单位下抄表设备列表
   * deviceNo: 非必填
   * deviceName: 设备名称
   * ownerName: 非必填
   * state:  非必填  开户状态  0 未开户 其他 已开户
   * @param deductionFeeDay : 抄表日期
   * deviceState: 非必填  设备联网状态
   * state232:  非必填  开合闸状态
   * @param meterType : 表类型 electric：电表  water：水表
   */
  getUnitMeterReadingConfigLimit: (unitId, pageIndex, pageSize, deviceNo, deviceName, ownerName, state, state232, deviceState, deductionFeeDay, meterType, success,
    failure) => {
    //debugger
    Axios.post('/meterReading/getUnitMeterReadingConfigLimit.do', {
      unitId,
      pageIndex,
      pageSize,
      deviceNo,
      deviceName,
      ownerName,
      state,
      state232,
      deviceState,
      deductionFeeDay,
      meterType
    }, success, failure)
  },
  /**
   * 导出扣费信息
   * @param unitId : 单位id，默认当前登录用户单位
   * @param deviceNo : 设备no 过滤条件 非必填
   * @param ownerName : 业主名称 过滤条件 非必填
   * @param state : 设备状态 过滤条件 非必填
   * @param deductionFeeDay : 抄表日期
   * @param accountType : 账单类型
   * @param meterType ： 表类型 electric：电表  water：水表
   */
  exportUnitMeterReadingConfig (unitId, deviceNo, ownerName, state, deductionFeeDay, accountType, meterType, success, failure) {
    Axios.post('/meterReading/exportUnitMeterReadingConfig.do', {
      unitId,
      deviceNo,
      ownerName,
      state,
      deductionFeeDay,
      accountType,
      meterType,
    }, success, failure)
  },
  /**
   * 控制设备（合闸/开闸）
   * ownerId 业主id 必填
   * deviceNo: 必填
   * endState: 必填 当前设备状态 0/1
   * password: 必填
   */
  controlMeter: (ownerId, deviceNo, endState, password, success,
    failure) => {
    Axios.post('/meterReading/controlMeter.do', {
      ownerId,
      deviceNo,
      endState,
      password
    }, success, failure)
  },
  //******************************************************************************************************************业主管理

  /**
   * 分页查询业主列表
   * @param {isBalanceAlert} 余额告警查询
   * @param {unitId} 公司id
   * @param {pageIndex} :页码
   * @param {pageSize} :页长
   * @param {rfid} :业主编号
   * @param {name} :业主名称
   * @param {mobile} :手机号
   * @param {isBindDevice} :是否绑定电表 true/false
   * @param {warning} :是否告警用户 true/false
   */
  getOwnerList: (unitId, pageIndex, pageSize, rfid, name, mobile, isBindDevice, warning, success, failure) => {
    Axios.post('/meterReading/getOwnerList.do', {
      unitId,
      pageIndex,
      pageSize,
      rfid,
      name,
      mobile,
      isBindDevice,
      warning
    }, success, failure)
  },
  /**
   * 导出查询业主列表
   * @param {unitId} 公司id
   * @param {pageIndex} :页码
   * @param {pageSize} :页长
   * @param {rfid} :业主编号
   * @param {name} :业主名称
   * @param {mobile} :手机号
   * @param {isBindDevice} :是否绑定电表 true/false
   * @param {warning} :是否告警用户 true/false
   */
  exportOwnerList: (rfid, name, mobile, isBindDevice, warning, success, failure) => {
    Axios.post('/meterReading/exportOwnerList.do', {
      rfid,
      name,
      mobile,
      isBindDevice,
      warning
    }, success, failure)
  },
  /**
   * 获取业主已关联电表信息
   * @param {ownerId} :业主id
   */
  getDeviceListByOwner (ownerId, success, failure) {
    Axios.post('/meterReading/getDeviceListByOwner.do', {
      ownerId,
    }, success, failure)
  },

  /**
   * 获取业主已关联电表信息
   * @param {ownerId} :业主id
   */
  getUserDeviceList (userId, success, failure) {
    Axios.post('/meterReading/getUserDeviceList.do', {
      userId,
    }, success, failure)
  },

  /**
   * 获取所有已经被业主关联的电表no
   */
  getAllBindOwnerDeviceNo (success, failure) {
    Axios.post('/meterReading/getAllBindOwnerDeviceNo.do', {}, success, failure)
  },

  //******************************************************************************计费方式*******************************

  /**
   * 保存计费方式
   * @param {Long} :pkid
   * @param {String} :name
   * @param {String} :billingMode
   * @param {String} :deductionStandard
   * @param {String} :unitId
   * @param activeName:区分水表、。电表等  first电表；second水表。。。。
   */
  saveMeterBillingMode: (pkid, name, activeName, billingMode, deductionStandard, unitId, success, failure) => {
    Axios.post('/meterReading/saveMeterBillingMode.do', {
      pkid,
      name,
      activeName,
      billingMode,
      deductionStandard,
      unitId,
    }, success, failure)
  },
  /**
   * 获取所有计费方式
   * @param {String} :unitId 单位id
   * @param 表类型：first电表  second水表
   */
  getAllMeterBillingMode (unitId, activeName, success, failure) {
    //debugger
    Axios.post('/meterReading/getAllMeterBillingMode.do', {
      unitId,
      activeName,
    }, success, failure)
  },
  /**
   * 删除指定计费方式
   * @param {Long} :pkid
   */
  deleteMeterBillingMode (pkid, success, failure) {
    Axios.post('/meterReading/deleteMeterBillingMode.do', {
      pkid,
    }, success, failure)
  },
  //******************************************************************************操作记录*******************************
  /**
   * 撤销退费
   * @param {Long} :noticeId 操作记录主键
   */
  refund (noticeId, fee, password, success, failure) {
    Axios.post('/meterReading/refund.do', {
      noticeId,
      fee,
      password,
    }, success, failure)
  },
  /**
   * 手动退费
   * @param userId 用户id
   * @param deviceNo 退款设备号
   * @param refType:1==退余额；2==退电量
   * @param conversionRate:退款金额转电度转换率
   */
  refundAmount (conversionRate, deviceNo, refType, targetId, fee, password, success, failure) {
    //debugger
    Axios.post('/meterReading/refundAmount.do', {
      conversionRate,
      deviceNo,
      refType,
      targetId,
      fee,
      password,
    }, success, failure)
  },
  /**
   * 郎瑞杰--预付费退费
   * @param userId 用户id
   */
  refundMeterAmount (targetId, fee, password, success, failure) {
    Axios.post('/meterReading/refundMeterAmount.do', {
      targetId,
      fee,
      password,
    }, success, failure)
  },
  //******************************************************************************统计报表*******************************
  /**
   * 统计指定设备指定时间近一年的电费账单（如果当前月为生成账单会实时计算）
   * @param {int} :deviceNo
   * @param {Long} :time
   */
  countElectricQuantityAndAmount (deviceNo, time, success, failure) {
    Axios.post('/meterReading/countElectricQuantityAndAmount.do', {
      deviceNo,
      time,
    }, success, failure)
  },
  /**
   * 分页获取指定设备指定时间范围的电费账单 /meterReading/getElectricityBill.do
   * @param {String} :unitId
   * @param {int} :pageIndex
   * @param {int} :pageSize
   * @param {String} :deviceNos 过滤条件 非必填
   * @param {String} :ownerName 过滤条件 非必填
   * @param {int} :state 过滤条件 非必填
   * @param {Long} :beginTime 过滤条件 非必填
   * @param {Long} :eintndTime 过滤条件 非必填
   * @param {int} :accountType	账单类型
   * @param {String} :meterType 表类型 electric：电表  water：水表
   * @param {String} :meterRunType 1预付费电表 2普通电表（远控表）
   * @param {String} :userId 业主id（用户Id）
   */
  getElectricityBill (userId, meterType, unitId, pageIndex, pageSize, deviceNos, ownerName, state, beginTime, endTime, accountType, meterRunType, success, failure) {
    Axios.post('/meterReading/getElectricityBill.do', {
      userId,
      meterType,
      unitId,
      pageIndex,
      pageSize,
      deviceNos,
      ownerName,
      state,
      beginTime,
      endTime,
      accountType,
      meterRunType
    }, success, failure)
  },


  /**
   * 分页获取指定设备指定时间范围的电费账单 == 每个业主产生一条数据
   * @param {String} :unitId
   * @param {int} :pageIndex
   * @param {int} :pageSize
   * @param {String} :deviceNos 过滤条件 非必填
   * @param {String} :ownerName 过滤条件 非必填
   * @param {int} :state 过滤条件 非必填
   * @param {Long} :beginTime 过滤条件 非必填
   * @param {Long} :eintndTime 过滤条件 非必填
   * @param {int} :accountType	账单类型
   * @param {String} :meterType 表类型 electric：电表  water：水表
   * @param {String} :meterRunType 1预付费电表 2普通电表（远控表）
   */
  getHandleElectricityBill (meterType, unitId, pageIndex, pageSize, deviceNos, ownerName, state, beginTime, endTime, accountType, meterRunType, success, failure) {
    Axios.post('/meterReading/getHandleElectricityBill.do', {
      meterType,
      unitId,
      pageIndex,
      pageSize,
      deviceNos,
      ownerName,
      state,
      beginTime,
      endTime,
      accountType,
      meterRunType
    }, success, failure)
  },


  /**
   * 财务报表
   * @param {String} :unitId
   * @param {String} :ownerName 过滤条件 非必填
   * @param {Long} :beginTime 过滤条件 非必填
   * @param {Long} :endTime 过滤条件 非必填
   * @param {int} :pageIndex
   * @param {int} :pageSize
   */
  getFinancialStatements (unitId, ownerName, beginTime, endTime, pageIndex, pageSize, success, failure) {
    Axios.post('/meterReading/getFinancialStatements.do', {
      unitId,
      ownerName,
      beginTime,
      endTime,
      pageIndex,
      pageSize,
    }, success, failure)
  },
  /**
   * 发送催缴短信
   * detailId 当前电费账单id
   * password: 必填
   */
  sendCallForMeter: (detailId, password, success,
    failure) => {
    Axios.post('/meterReading/sendCallForMeter.do', {
      detailId,
      password
    }, success, failure)
  },
  /**
   * 手动结清
   * detailId 当前电费账单id
   * fee 当前支付金额
   * password: 必填
   */
  manualClearing: (detailId, fee, password, success,
    failure) => {
    Axios.post('/meterReading/manualClearing.do', {
      detailId,
      fee,
      password
    }, success, failure)
  },
  //******************************************************************************默认参数*******************************
  /**
   * 添加默认参数
   * @param {String} unitId  单位id
   * @param {String} deductionFeeDay  扣费日期，精确到天即可
   * @param {String} balanceAlarm  余额告警值，业主账户低于这个设置会产生事件
   * @param {String} basicElectricityCharges  基本电费单价
   * @param {String} icbcAppId  应用appid
   * @param {String} icbcUnitCode  单位简称  全英文不超过6位
   * @param {String} icbcCorpCis  企业客户编号
   * @param {String} icbcProjectId  项目编号
   * @param {String} wxMchId 微信子商户号
   */
  saveBaseMeterDefault (unitId, deductionFeeDay, balanceAlarm, basicElectricityCharges, icbcAppId, icbcUnitCode, icbcCorpCis, icbcProjectId, wxMchId, roleId, success, failure) {
    Axios.post('/meterReading/saveBaseMeterDefault.do', {
      unitId,
      deductionFeeDay,
      balanceAlarm,
      basicElectricityCharges,
      icbcAppId,
      icbcUnitCode,
      icbcCorpCis,
      icbcProjectId,
      wxMchId,
      roleId,
    }, success, failure)
  },
  /**
   * 获取单位默认参数
   */
  getBaseMeterDefault (unitId, success, failure) {
    Axios.post('/meterReading/getBaseMeterDefault.do', {
      unitId,
    }, success, failure)
  },
  /**
   * 工商银行代扣
   * 将未签约业主置为已签约业主
   * @param {String} :ownerIds 业主id集合
   * @param {String} :password 当前登录用户密码
   */
  updateOwnerToSigned (ownerIds, password, success, failure) {
    Axios.post('/meterReading/updateOwnerToSigned.do', {
      ownerIds,
      password,
    }, success, failure)
  },
  /**
   * 导出电费账单excel表格
   * deviceNos 电表id
   * ownerName 业主姓名 支持模糊查询
   * state 0未缴费 1已缴费 -1无效 -2超时
   * accountType 账单类型
   * @param meterType:表类型 electric：电表  water：水表
   */
  exportElectricityBill: (meterRunType, meterType, unitid, deviceNos, ownerName, state, beginTime, endTime, accountType, success, failure) => {
    Axios.post('/meterReading/exportElectricityBill.do', {
      meterRunType,
      meterType,
      unitid,
      deviceNos,
      ownerName,
      state,
      beginTime,
      endTime,
      accountType,
    }, success, failure)
  },
  /**
   * 财务报表导出
   * ownerName 业主姓名 支持模糊查询
   */
  exportFinancialStatements: (unitid, ownerName, beginTime, endTime, success, failure) => {
    Axios.post('/meterReading/exportFinancialStatements.do', {
      unitid,
      ownerName,
      beginTime,
      endTime,
    }, success, failure)
  },
  /**
   * 运维报告上传
   * resourcesId 文件上传后返回的主键id
   * password	当前登录用户密码 二次验证
   */
  importUnitMonthReport: (resourcesId, password, success, failure) => {
    Axios.post('/meterReading/importUnitMonthReport.do', {
      resourcesId,
      password,
    }, success, failure)
  },
  /**
   * 电费账单导出
   * ownerId 业主id
   * deviceNos  设备编号
   * beginTime  开始时间
   * endTime    结束时间
   */
  exportOwnerElectricityBill: (ownerId, deviceNos, beginTime, endTime, success, failure) => {
    Axios.post('/meterReading/exportOwnerElectricityBill.do', {
      ownerId,
      deviceNos,
      beginTime,
      endTime,
    }, success, failure)
  },
}